import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBreakerComponent } from './simple-icons-breaker.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBreakerComponent ],
    exports:      [ SimpleIconsBreakerComponent ],
    bootstrap:    []
})
export class SimpleIconsBreakerModule {}
